import scrollDir from '/javascripts/lib/scrolldir'

scrollDir({ el: document.body })
